import React from "react";
import PropTypes from "prop-types";
import cnames from "classnames";

import Box from "@redbubble/design-system/react/Box";
import { CENTER } from "@redbubble/design-system/react/constants";

import styles from "./TabList.scss";

const TabList = ({ children, position }) => {
  const classNames = cnames(styles.container, {
    [styles.center]: position === CENTER,
  });

  return (
    <Box className={classNames} marginTop="m">
      {children}
    </Box>
  );
};

TabList.propTypes = {
  children: PropTypes.node,
  position: PropTypes.string,
};

TabList.defaultProps = {
  children: undefined,
  position: undefined,
};

export default TabList;
